module.exports = __webpack_public_path__ + "img/ic-neck-pink.b11a7902.svg";